/**
 * utils/stringHelpers.ts
 *
 * Shared string utility functions used across the application.
 * Updated: added getGreeting() for dynamic time-of-day greeting with emoji.
 */

export interface Greeting {
  emoji: string;
  text: string;
  full: string;
}

export function getGreeting(firstName?: string | null): Greeting {
  const hour = new Date().getHours();

  let emoji: string;
  let salutation: string;

  if (hour >= 6 && hour < 12) {
    emoji = '☀️';
    salutation = 'Bonjour';
  } else if (hour >= 12 && hour < 19) {
    emoji = '☀️';
    salutation = 'Bon après-midi';
  } else if (hour >= 19 && hour < 21) {
    emoji = '🌙';
    salutation = 'Bonsoir';
  } else {
    emoji = '🌙';
    salutation = 'Bonne nuit';
  }

  const text = firstName ? `${salutation}, ${firstName}` : salutation;

  return { emoji, text, full: `${emoji} ${text}` };
}

export function getInitials(name: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? '?';
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
